import React from 'react';
import Banner from './Banner';
import './Banner.css';

const Banners = () => {
    return (
        <>
            <section className='homeSlide contentWidth'>
                <div className='container'>
                    <Banner />
                </div>
            </section>
        </>
    );
};

export default Banners;